// ==============================================
// ===================Imports====================
// ==============================================
// ==============================================

// =================ACTIONS=====================
import { SAVE_FULL_ONE_STATION_DATA } from '../actions/dataAPI';
import {
  DISPLAY_DOI,
  DISPLAY_IMAGES,
  SAVE_CALENDAR_DATA,
  SAVE_DATE_ELEMENTS,
  SAVE_DOI_AND_LICENCE,
  SAVE_IMAGES,
  SAVE_QUALITY_DATA,
  SAVE_STATION_SHORT_DATA,
  SAVE_TIME_SERIES,
  SET_CURRENT_DATE,
  SET_DATE_HIGHLIGHT,
  SET_DATE_PICKER_DATE_FROM,
  SET_DATE_PICKER_DATE_TO,
  SET_DATE_SELECTED_ARRAY,
  SET_DOWNLOAD_BUTTON,
  SET_FETCH_DATA,
  SET_FULL_DATA_AVAILABLE,
  SET_HEATMAP_OPTIONS,
  SET_LINEAR_OPTIONS,
  SET_LOADING_FULL_DATA,
  SET_OPEN_MODAL,
  SET_QUALITY_DATE_PICKER_DATE_FROM,
  SET_QUALITY_DATE_PICKER_DATE_TO,
  SET_QUALITY_HIGHCHARTS,
  SET_RESPONSE_IMAGE,
  SET_SAVE_ANTENNA_LIST,
  SET_SAVE_FREQUENCY_STANDARD_SENSOR_LIST,
  SET_SAVE_FULL_ONE_STATION_DATA,
  SET_SAVE_HUMIDITY_SENSOR_LIST,
  SET_SAVE_PRESSURE_SENSOR_LIST,
  SET_SAVE_RADOME_LIST,
  SET_SAVE_RECEIVER_LIST,
  SET_SAVE_SESSION_VIEW_DATA,
  SET_SAVE_TEMPERATURE_SENSOR_LIST,
  SET_SAVE_WATER_VAPOR_SENSOR_LIST,
  SET_SHIFTKEY,
} from '../actions/metadata';

// ================InitialState==================
const initialState = {
  data: {
    currentDate: '',
    fullDataAvailable: true,
    loadingFullData: true,
    stationShortData: [],
    saveFullData: false,
    stationFullData: [],
    instrumentation: {
      sessionViewData: [],
      antennaList: [],
      radomeList: [],
      receiverList: [],
      humiditySensorList: [],
      pressureSensorList: [],
      temperatureSensorList: [],
      waterVaporSensorList: [],
      frequencyStandardSensorList: [],
    },
    datePicker: {
      dateTo: '',
      dateFrom: '',
    },
    heatmap: {
      options: {},
    },
    linear: {
      options: {},
    },
    shiftkey: false,
    calendar: {
      fetchData: false,
      calendarData: [],
      dateElements: {},
      dateSelectedArray: [],
      dateHighlight: [],
      downloadButton: false,
    },
    modal: {
      openModal: false,
    },
    quality: {
      dateTo: '',
      dateFrom: '',
      qualityData: [],
      qualityHighlight: [],
    },
    dataDoi: {
      DOIAndLicence: [],
      displayDOI: false,
      images: [],
      responseImage: false,
      displayImages: false,
      timeseries: [],
    },
  },
};

// ==============================================
// ===================Reducer====================
// ==============================================

function metadataReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_LOADING_FULL_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          loadingFullData: action.value,
        },
      };
    case SAVE_STATION_SHORT_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          stationShortData: action.value,
        },
      };
    case SAVE_FULL_ONE_STATION_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          stationFullData: action.fullData,
        },
      };
    case SET_SAVE_FULL_ONE_STATION_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          saveFullData: action.value,
        },
      };
    case SET_FULL_DATA_AVAILABLE:
      return {
        ...state,
        data: {
          ...state.data,
          fullDataAvailable: action.value,
        },
      };
    case SET_SAVE_SESSION_VIEW_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          instrumentation: {
            ...state.data.instrumentation,
            sessionViewData: action.value,
          },
        },
      };
    case SET_SAVE_ANTENNA_LIST:
      return {
        ...state,
        data: {
          ...state.data,
          instrumentation: {
            ...state.data.instrumentation,
            antennaList: action.value,
          },
        },
      };
    case SET_SAVE_RADOME_LIST:
      return {
        ...state,
        data: {
          ...state.data,
          instrumentation: {
            ...state.data.instrumentation,
            radomeList: action.value,
          },
        },
      };
    case SET_SAVE_RECEIVER_LIST:
      return {
        ...state,
        data: {
          ...state.data,
          instrumentation: {
            ...state.data.instrumentation,
            receiverList: action.value,
          },
        },
      };
    case SET_SAVE_HUMIDITY_SENSOR_LIST:
      return {
        ...state,
        data: {
          ...state.data,
          instrumentation: {
            ...state.data.instrumentation,
            humiditySensorList: action.value,
          },
        },
      };
    case SET_SAVE_PRESSURE_SENSOR_LIST:
      return {
        ...state,
        data: {
          ...state.data,
          instrumentation: {
            ...state.data.instrumentation,
            pressureSensorList: action.value,
          },
        },
      };
    case SET_SAVE_TEMPERATURE_SENSOR_LIST:
      return {
        ...state,
        data: {
          ...state.data,
          instrumentation: {
            ...state.data.instrumentation,
            temperatureSensorList: action.value,
          },
        },
      };
    case SET_SAVE_WATER_VAPOR_SENSOR_LIST:
      return {
        ...state,
        data: {
          ...state.data,
          instrumentation: {
            ...state.data.instrumentation,
            waterVaporSensorList: action.value,
          },
        },
      };
    case SET_SAVE_FREQUENCY_STANDARD_SENSOR_LIST:
      return {
        ...state,
        data: {
          ...state.data,
          instrumentation: {
            ...state.data.instrumentation,
            frequencyStandardSensorList: action.value,
          },
        },
      };
    case SET_DATE_PICKER_DATE_FROM:
      return {
        ...state,
        data: {
          ...state.data,
          datePicker: {
            ...state.data.datePicker,
            dateFrom: action.value,
          },
        },
      };
    case SET_DATE_PICKER_DATE_TO:
      return {
        ...state,
        data: {
          ...state.data,
          datePicker: {
            ...state.data.datePicker,
            dateTo: action.value,
          },
        },
      };
    case SET_CURRENT_DATE:
      return {
        ...state,
        data: {
          ...state.data,
          currentDate: action.value,
        },
      };
    case SET_HEATMAP_OPTIONS:
      return {
        ...state,
        data: {
          ...state.data,
          heatmap: {
            ...state.data.heatmap,
            options: action.value,
          },
        },
      };
    case SET_LINEAR_OPTIONS:
      return {
        ...state,
        data: {
          ...state.data,
          linear: {
            ...state.data.linear,
            options: action.value,
          },
        },
      };
    case SET_SHIFTKEY:
      return {
        ...state,
        data: {
          ...state.data,
          shiftkey: action.value,
        },
      };
    case SET_FETCH_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          calendar: {
            ...state.data.calendar,
            fetchData: action.value,
          },
        },
      };
    case SAVE_CALENDAR_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          calendar: {
            ...state.data.calendar,
            calendarData: action.value,
          },
        },
      };
    case SAVE_DATE_ELEMENTS:
      return {
        ...state,
        data: {
          ...state.data,
          calendar: {
            ...state.data.calendar,
            dateElements: action.value,
          },
        },
      };
    case SET_DATE_SELECTED_ARRAY:
      return {
        ...state,
        data: {
          ...state.data,
          calendar: {
            ...state.data.calendar,
            dateSelectedArray: action.value,
          },
        },
      };
    case SET_DATE_HIGHLIGHT:
      return {
        ...state,
        data: {
          ...state.data,
          calendar: {
            ...state.data.calendar,
            dateHighlight: action.value,
          },
        },
      };
    case SET_OPEN_MODAL:
      return {
        ...state,
        data: {
          ...state.data,
          modal: {
            ...state.data.modal,
            openModal: action.value,
          },
        },
      };
    case SET_DOWNLOAD_BUTTON:
      return {
        ...state,
        data: {
          ...state.data,
          calendar: {
            ...state.data.calendar,
            downloadButton: action.value,
          },
        },
      };
    case SET_QUALITY_DATE_PICKER_DATE_FROM:
      return {
        ...state,
        data: {
          ...state.data,
          quality: {
            ...state.data.quality,
            dateFrom: action.value,
          },
        },
      };
    case SET_QUALITY_DATE_PICKER_DATE_TO:
      return {
        ...state,
        data: {
          ...state.data,
          quality: {
            ...state.data.quality,
            dateTo: action.value,
          },
        },
      };
    case SAVE_QUALITY_DATA:
      return {
        ...state,
        data: {
          ...state.data,
          quality: {
            ...state.data.quality,
            qualityData: action.value,
          },
        },
      };
    case SET_QUALITY_HIGHCHARTS:
      return {
        ...state,
        data: {
          ...state.data,
          quality: {
            ...state.data.quality,
            qualityHighcharts: action.value,
          },
        },
      };
    case SAVE_DOI_AND_LICENCE:
      return {
        ...state,
        data: {
          ...state.data,
          dataDoi: {
            ...state.data.dataDoi,
            DOIAndLicence: action.value,
          },
        },
      };
    case DISPLAY_DOI:
      return {
        ...state,
        data: {
          ...state.data,
          dataDoi: {
            ...state.data.dataDoi,
            displayDOI: action.value,
          },
        },
      };
    case SAVE_IMAGES:
      return {
        ...state,
        data: {
          ...state.data,
          dataDoi: {
            ...state.data.dataDoi,
            images: action.value,
          },
        },
      };
    case DISPLAY_IMAGES:
      return {
        ...state,
        data: {
          ...state.data,
          dataDoi: {
            ...state.data.dataDoi,
            displayImages: action.value,
          },
        },
      };
    case SAVE_TIME_SERIES:
      return {
        ...state,
        data: {
          ...state.data,
          dataDoi: {
            ...state.data.dataDoi,
            timeseries: action.value,
          },
        },
      };
    case SET_RESPONSE_IMAGE:
      return {
        ...state,
        data: {
          ...state.data,
          dataDoi: {
            ...state.data.dataDoi,
            responseImage: action.value,
          },
        },
      };
    default:
      return state;
  }
}

export default metadataReducer;
